module.exports = __webpack_public_path__ + "img/img_theme-nights.4f414568.jpg";